export default __webpack_public_path__ + "static/media/no-product-syndications.af343d48.svg";